<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<template>
<div style="width: 42% !important;margin-left: 29%;">
  <div style="margin-top: 5%;text-align: center;font-size: 30px;">您的订单已提交，请尽快支付</div>
  <div class="text-red" style="margin-top: 10px;text-align: center;font-size: 30px;">￥{{ payPrice/100 }}</div>
  <img :src="EWMUrl" style="width: 60%;margin-left: 20%;"/>
  <div style="text-align: center;font-size: 30px;">打开微信扫一扫，扫码付款</div>
  <div style="text-align: center;font-size: 30px;color: #7eb0f7;margin-top: 20px;" @click="pageAppJump()">点击查看已支付订单</div>
</div>
</template>
<script>
import wx from 'weixin-js-sdk'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
export default {
  name: 'payCode',
  data () {
    return {
      requestHeadUrl: 'https://zhenqing.kequbang.com',
      // requestHeadUrl: 'http://localhost:8122',
      // requestHeadUrl22: 'http://localhost:8122',
      requestHeadUrl22: 'https://zhenqing.kequbang.com',
      // requestHeadUrl22: 'http://192.168.137.1:8122',
      isOpenVipModular: false,
      showModal: false, // 是否展示弹窗
      EWMUrl: '',
      payPrice: ''
    }
  },
  created () {
    
    let canvas = document.createElement('canvas')
    // 用 canvas 对象和邀请链接生成二维码，并将生成的二维码转为 base64
    // console.log("12121212")
    // console.log(this.$root.codeUrl)
    this.payPrice = this.$root.payPrice
    QRCode.toCanvas(canvas, this.$root.codeUrl, (error) => {
      if (error) {
          console.log(error)
      } else {
        this.EWMUrl = canvas.toDataURL('image/jpeg')
      }
    })
  },
  methods: {
    onLoad: function () {
      // this.navigateToMiniProgram(JSON.stringify(payParam))
      var rr = window.location.href.split('/')
      //9d03442a91c345709dcbcd85daab9cc4
      var gid = rr[rr.length-1].split('-')[0]
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/p/goods/getByGoodId?goodId='+ gid +'&storeId=storezhenqing&linkId='+rr[rr.length-1], {}).then(res => {
        // console.log(res)
        res.goodsImgs = res.goodsImgs.split(",");
        res.goodsDetailImgs = res.goodsDetailImgs.split(",");
        thisObj.info = res 
        thisObj.goodsAttributes = JSON.parse(res.goodsAttributes)
        // console.log(thisObj.info)
        // console.log(thisObj.goodsAttributes)
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
      
      this.setTime()
    },
    getInfos() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/admin/goodsLink/getById?id='+ thisObj.getId +'&storeId=storezhenqing&linkId=', {}).then(res => {
        // console.log(res)
        res.goodsImgs = res.goodsImgs.split(",");
        res.goodsDetailImgs = res.goodsDetailImgs.split(",");
        thisObj.info = res 
        thisObj.goodsAttributes = JSON.parse(res.goodsAttributes)
        thisObj.titleName = res.goodsName
        thisObj.infoState = true
        // this.getLongitudeLatitude()
        // console.log(res.endTime.replace("-","/")+":00")
        this.swiperList = res.goodsImgs;
        console.log(this.swiperList)
        // console.log(thisObj.info)
        // console.log(thisObj.goodsAttributes)
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    getLongitudeLatitude() {
      var that = this
      //如果该对象存在，那么地理位置服务可用。
      if ('geolocation' in navigator) {
        /* 地理位置服务可用 */
        var options = {
          enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
          timeout: 5000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
          maximumAge: 0 //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
        }
        function success(position) {
          
          //position.coords (只读) 返回一个定义了当前位置的Coordinates对象。
          //position.timestamp (只读) 返回一个时间戳DOMTimeStamp， 这个时间戳表示获取到的位置的时间。
          var lat = position.coords.latitude //当前位置的纬度
          var lon = position.coords.longitude //当前位置精度
          that.lat = lat
          that.lon = lon
          that.getShops()
          // alert(lat + "A233A" + lng)
        }
        function error(err) {
          console.log(err)
          var errorType = ['您拒绝共享位置信息', '获取不到位置信息', '获取位置信息超时']
          console.log(errorType[err.code - 1])
          // alert(errorType[err.code - 1])
          that.getShops()
        }
 
        navigator.geolocation.getCurrentPosition(success, error, options)
      } else {
        /* 地理位置服务不可用 */
        console.log('无法获取您的位置，请检查定位是否开启或刷新重试')
      }
    },
    getShops() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/group/shop/getAllShopsByGoods?goodsId='+thisObj.info.id, {}).then(res => {
        // console.log(res)
        thisObj.shopList = res
        var shopNames = []
        for (const i in res) {
          shopNames.push(res[i].shopName)
        }
        thisObj.columns = shopNames
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },

    goApp() {
      location.href=this.appLink
    },
    tabSelect(e) {
      this.TabCur = e
    },
    pageAppJump () {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: '/orderList',
        query: queryData
      })
    },
    // 页面跳转
    pageJump (uri, item) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    setTime() {
      var date = new Date() //1. js获取当前时间
      var min = date.getMinutes() //2. 获取当前分钟
      date.setMinutes(min + 10) //3. 设置当前时间+10分钟：把当前分钟数+10后的值重新设置为date对象的分钟数
      var y = date.getFullYear()
      var m = (date.getMonth() + 1) < 10 ? ("0" + (date.getMonth() + 1)) : (date.getMonth() + 1);
      var d = date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate()
      var h = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
      var f = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes();
      var s = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
      var formatdate = y + '-' + m + '-' + d + " " + h + ":" + f + ":" + s;
      console.log(formatdate)
      this.endDate2 = formatdate
      this.countTime()
    },
    countTime() {
      var that = this;
      var date = new Date();
      var now = date.getTime();
      var endDate = new Date(that.endDate2); //设置截止时间
      var end = endDate.getTime();
      var leftTime = end - now; //时间差
      var d, h, m, s, ms;
      if (leftTime >= 0) {
        d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
        m = Math.floor(leftTime / 1000 / 60 % 60);
        s = Math.floor(leftTime / 1000 % 60);
        ms = Math.floor(leftTime % 1000);
        ms = ms < 100 ? "0" + ms : ms
        s = s < 10 ? "0" + s : s
        m = m < 10 ? "0" + m : m
        h = h < 10 ? "0" + h : h
        that.countdown = m + ":" + s + "." + ms,
        //递归每秒调用countTime方法，显示动态时间效果
        setTimeout(that.countTime, 100);
      } else {
        console.log('已截止')
        that.countdown = '00:00:00'
      }
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    shopChooseShop() {
      this.showShop = true
    },
    onChange(e) {
      console.log(e)
      this.chooseShop = e
      this.showShop = false
    },
    shopChooseDate() {
      this.showDate = true
    },
    onTimeChange(date) {
      console.log(date)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1) < 10 ? ("0" + (date.getMonth() + 1)) : (date.getMonth() + 1);
      var d = date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate()
      var h = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
      var f = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes();
      var formatdate = y + '-' + m + '-' + d + " " + h + ":" + f
      this.chooseDate = formatdate
      this.showDate = false
    },
    payMoney() {
      // location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd5ba93934e0b0e5b&redirect_uri=https://zxy.kequbang.com&response_type=code&scope=snsapi_base&state=111#wechat_redirect"
      var that = this
      if(!that.dk) { // pc端支付
        that.commitPCPay()
      }
      return
      var wx = window.navigator.userAgent.toLowerCase();
      let params = this.$route.query;
      if (wx.match(/MicroMessenger/i) == 'micromessenger'){
        that.commitPay();
      } else {
        return
      }
      // alert(that.wxCode)
      return
      wx.config({
        debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印
        appId: 'wxd5ba93934e0b0e5b', // 必填，公众号的唯一标识
        timestamp: '1687510862', // 必填，生成签名的时间戳
        nonceStr: '1687510862473', // 必填，生成签名的随机串
        signature: '8E272500926E2C69BD4A67D89C80FF93',// 必填，签名
        jsApiList: ["checkJsApi", "chooseWXPay"], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp','chooseWXPay'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      });
      wx.chooseWXPay({
        timestamp: '1687510862', // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: '1687510862473', // 支付签名随机串，不长于 32 位
        package: "wx23170102348582e31e6da6b33f4ed10000", // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: "8E272500926E2C69BD4A67D89C80FF93", // 支付签名
        success: function (res) {
          // 支付成功后的回调函数
          // person.isVip = 1;
          // this.isVip = 1;
          // this.$root.userInfo = person;
          that.$util.showSuccessMsg("开通会员成功");
        },
        cancel: function () {
          alert("支付已取消");
        },
        error: function (e) {},
      });


    },

    commitPay () {
      var that = this
      var isLogin = that.$root.isLogin = true
      var wx = require('weixin-js-sdk')
      var href = window.location.href
      var urlConfig = that.requestHeadUrl + '/p/order'
      // var urlConfig = that.requestUrl + '/weixin/get/knowledge/config?fromDevice=h5'
      const thisObj = this
      thisObj.$api.post(thisObj.requestHeadUrl22 + '/p/order/get/js/config', {url: href}).then(res => {
        console.log(res)
        console.log(res.sign)
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appid, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.noncestr, // 必填，生成签名的随机串
          signature: res.sign, // 必填，签名
          jsApiList: ['checkJsApi', 'chooseWXPay'] // 必填，需要使用的JS接口列表
        })
        
        wx.ready(res => {
          wx.checkJsApi({
            jsApiList: ['chooseWXPay'],
            success: res => {
              console.log('checked api:', res)
            },
            fail: err => {
              console.log('check api fail:', err)
            }
          })
        })
        // wx.ready(function(){

        //   console.log('ok')
        //   // config信息验证后会执行 ready 方法，所有接口调用都必须在 config 接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在 ready 函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在 ready 函数中。
        // });
        wx.error(function(res){
          // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
          console.log("验证失败")
          console.log(res)
        });
        var postData = {
          code:that.wxCode,
          userName:that.userName,
          userPhone:that.userPhone,
          notes:that.notes,
          skuName:that.values,
          getId:that.getId,
          payType: 1,
          reservationShop: that.reservationShop,
          reservationShopName:that.chooseShop,
          reservationTime: that.chooseDate
        }
        thisObj.$api.post(thisObj.requestHeadUrl22 + '/p/order/payYx', postData).then(result => {
          
          wx.chooseWXPay({
            timestamp: result.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: result.nonceStr, // 支付签名随机串，不长于 32 位
            package: result.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: result.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: result.paySign, // 支付签名
            success: function (res) {
              // 支付成功后的回调函数
              that.$util.showSuccessMsg('成功')
            },
            cancel: function () {
              alert('支付已取消')
            },
            error: function (e) {
              // alert(e)
            }
          })
        }).catch(function (error) {
          thisObj.$util.requetServerError(error)
        })

      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    
    commitPCPay () {
      var that = this
      var isLogin = that.$root.isLogin = true
      var wx = require('weixin-js-sdk')
      var href = window.location.href
      var urlConfig = that.requestHeadUrl + '/p/order'
      // var urlConfig = that.requestUrl + '/weixin/get/knowledge/config?fromDevice=h5'
      const thisObj = this
      var postData = {
        code:that.wxCode,
        userName:that.userName,
        userPhone:that.userPhone,
        notes:that.notes,
        skuName:that.values,
        getId:that.getId,
        payType: 2,
        reservationShop: that.reservationShop,
        reservationShopName:that.chooseShop,
        reservationTime: that.chooseDate
      }
      thisObj.$api.post(thisObj.requestHeadUrl22 + '/p/order/payYx', postData).then(result => {
          console.log(result)
          result.codeUrl
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
  }
}
</script>

<style>
.bg-e {
  background: #eeeeee;
}
.margin-top {
    margin-top: 30px;
}
.grid {
    display: flex;
    flex-wrap: wrap;
}
.justify-between {
    justify-content: space-between;
}
.align-center {
    align-items: center;
}
.text-xxl {
    font-size: 44px;
}
.margin {
    margin: 30px;
}
.half-angle {
    box-shadow: 1rpx 2rpx 18rpx 0rpx rgba(0, 0, 0, 0.12);
    border-radius: 40rpx;
}
.bg-white {
    background-color: var(--white);
    color: var(--darkGray);
}
.padding {
    padding: 30px;
}
.text-cut {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.text-xl2 {
    font-size: 33px;
}
.flex {
    display: flex;
}
.grid.col-2>div {
    width: 50%;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.text-center {
    text-align: center;
}
.text-bold {
    font-weight: bold;
}
.text-xl {
    font-size: 36px;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding {
    padding: 30px;
}
.padding-top {
    padding-top: 30px;
}
.b-b {
    border-bottom: 2px solid #CFCFCF;
}
.padding-sm {
    padding: 20px;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.text-bold {
    font-weight: bold;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}

.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}

.shuxing {
  color: #ff6600;
  font-size: 29px;
  width: 29%;
  margin: 12px;
  border-radius: 20px;
  padding: 20px 8px;
  margin-top: 30px;
  background-color: #ffefe4;
  border: 2px solid #ff6600;
}
.an_shop2 {
  width: 40%;
  line-height: 80px;
  color: #fff;
  background-color: #ec3030;
  border-radius: 50px;
  text-align: center;
  font-size: 36px;
}
.half-angle {
    box-shadow: 1px 2px 18px 0px rgba(0, 0, 0, 0.12);
    border-radius: 40px;
}
.margin-top-sm {
    margin-top: 20px;
}
.margin-top-xs {
    margin-top: 13px;
}
.padding-top-sm {
    padding-top: 20px;
}
.padding-bottom-sm {
    padding-bottom: 20px;
}
.input1 {
  border: 0px !important;
  /* border-bottom: 1px solid #666666 !important; */
  text-align: center;
}
.oldp {
  text-decoration: line-through;
  color: #CFCFCF;
}
.text-red, .line-red, .lines-red {
    color: #e54d42;
}
.cu-form-group {
    background-color: #ffffff;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    min-height: 30px;
    justify-content: space-between;
}
.picker-c {
  position: fixed;
  width: 100%;
  z-index: 999;
  bottom: 0px;
  left: 0px;
}
.picker-c2 {
  position: fixed;
  min-width: 50% !important;
  z-index: 999;
  bottom: 0px;
  left: 0px;
}
</style>
